export default {
    data() {
        return {
            loggedIn: false
        }
    },

    methods: {
        async authentication() {
            if (process.env.NODE_ENV == 'production') {
                try {
                    native.getDeviceInfo();
                } catch (error) {
                    window.location.href = '/not-in-app';
                    return
                }
            }

            this.inApp = true

            if (process.env.NODE_ENV == 'production') {
                try {
                    const appSession = native.getStorage('session')

                    // User not login in app
                    if (appSession == "") {
                        localStorage.removeItem('token')
                    } else {
                        if (localStorage.getItem('token') === null) {
                            const { data } = await axios.post('/app-verify', {
                                'session': appSession
                            })

                            localStorage.setItem('token', data.token)
                            window.axios.defaults.headers['Authorization'] = `Bearer ${data.token}`
                        }
                    }
                } catch (error) {
                    alert(error)

                    window.location.href="/internal-error"
                }
            }

            // if local token exists, skip verify
            if (localStorage.getItem('token') !== null) {
                this.loggedIn = true
            }
        },
    }
}
